<template>
  <div>
     <section id="page-title">
        <div class="container clearfix">
          <h1 data-animate="fadeInUp">2017 WINTER</h1>
          <span data-delay="300" data-animate="fadeInUp">December</span> 
        </div>
      </section>
      <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div id="portfolio" class="portfolio-masonry clearfix">
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/01.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/01.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>

                        
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/02.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/02.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/03.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/03.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/04.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/04.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/05.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/05.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/06.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/06.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/07.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/07.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/08.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/08.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/v01.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/v01.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/v02.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/v02.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/correcionv03.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/correcionv03.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/correcionv04.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/correcionv04.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/09.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/09.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/10.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/10.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/11.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/11.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/correcion12.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/correcion12.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/13.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/13.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/14.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/14.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/correcion15.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/correcion15.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/correcion16.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/correcion16.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/17.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/17.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/18.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/18.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-winter/thumbs/19.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-winter/19.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <!--
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic21.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic21.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic22.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic22.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic23.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic23.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic24.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic24.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2017-spring/thumbs/smallpic25.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2017-spring/pic25.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        -->

                    </div>
                </div>
            </div>
        </section>
        <!-- #content end -->
  </div>
</template>
<script>
    import jQuery from 'jquery'
    export default {
    name: "2017Spring",
    components: {
    },
    mounted(){
        jQuery(window).load(function() {

        var $container = jQuery('#portfolio');

        $container.isotope({
            transitionDuration: '0.65s'
        });

        jQuery('#portfolio-filter a').click(function() {
            jQuery('#portfolio-filter li').removeClass('activeFilter');
            jQuery(this).parent('li').addClass('activeFilter');
            var selector = $(this).attr('data-filter');
            $container.isotope({
                filter: selector
            });
            return false;
        });

        jQuery('#portfolio-shuffle').click(function() {
            $container.isotope('updateSortData').isotope({
                sortBy: 'random'
            });
        });

        jQuery(window).resize(function() {
            $container.isotope('layout');
        });

    });
    }
  }
</script>
